import styled from 'styled-components';
import { colors, body2, spacing, fontWeights, easing, duration } from 'ui/theme';
import { ActionButtonWrapper as BaseActionButtonWrapper } from '../CriteriaLayout/CriteriaLayout.styles';
import { CONDITION_LAYOUT_DATA_TEST } from '../ConditionLayout/constants';
import { REQUIREMENT_LAYOUT_DATA_TEST } from './constants';

export const MainRow = styled.div`
  display: flex;
  flex-direction: column;
  &:hover,
  &:focus-within {
    background: ${colors.backgroundPrimaryHover};
    transition: all ${easing.entrance} ${duration.short};
    [data-test=${REQUIREMENT_LAYOUT_DATA_TEST.actionButtons}] {
      opacity: 1;
    }
  }
`;

export const ConditionRow = styled.div`
  flex-basis: 100%;
  width: 100%;
`;

export const Pretext = styled.div`
  ${body2}
  min-width: ${spacing.x8};
  &[data-first='true'] {
    font-weight: ${fontWeights.semiBold};
    color: ${colors.textPrimary};
  }
  color: ${colors.textSecondary};
`;

export const FirstRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.half} ${spacing.base};
  &:hover,
  &:focus-within {
    > * > [data-test=${REQUIREMENT_LAYOUT_DATA_TEST.conditionActionButtons}] {
      opacity: 1;
    }
    > * > * > * > [data-test=${CONDITION_LAYOUT_DATA_TEST.actionButtons}] {
      opacity: 1;
    }
  }
`;

export const FirstWrapper = styled.div`
  align-items: center;
  column-gap: ${spacing.half};
  display: flex;
  flex-direction: row;
  min-width: 0;
  width: 100%;
`;

export const ConditionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${spacing.half};
  align-items: center;
  padding: ${spacing.half} ${spacing.base};
  width: 100%;
  &:hover,
  &:focus-within {
    background: ${colors.backgroundSecondaryHover};
    transition: all ${easing.entrance} ${duration.short};
      > * > * > * > [data-test=${CONDITION_LAYOUT_DATA_TEST.actionButtons}] {
          opacity: 1;
      }
  }
`;

export const ActionButtonWrapper = styled(BaseActionButtonWrapper)`
  opacity: 0;
  margin-top: -${spacing.x3};
`;
